import React from 'react';
import cn from 'classnames';
import { isNil } from 'lodash';

import Permitted from 'components/core/Permitted.component';
import Icon from 'components/generic/Icon.component';
import TruncatedText from 'components/generic/TruncatedText.component';
import Cell from 'components/report/payment/Cell.component';
import PERM from 'constants/core/perm.const';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import { formatDayToYear, formatHourAndMinute } from 'utils/date/format.util';
import asObject from 'utils/objects/asObject.util';
import fixed from 'utils/values/fixed.util';

import CN from './SinglePayment.module.scss';

const DEFAULT_CLIENT_NAME = 'common.walkIn';

const SinglePayment = ({ payment, onOpenModal, hideModalForStylistsGroup, hideModalForSubPaymentsGroup }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const layoutClasses = cn({
    [CN.component]: true,
    [CN.dark]: isDarkMode,
  });

  const p = asObject(payment);

  //TODO: Date and hours localisation

  return (
    <div className={layoutClasses}>
      <Cell width="small">
        {formatDayToYear(p.created_at)}
        <br />
        {formatHourAndMinute(p.created_at)}
      </Cell>

      {!isNil(p.appointment_start_time) ? (
        <Cell width="small">
          {formatDayToYear(p.appointment_start_time)}
          <br />
          {formatHourAndMinute(p.appointment_start_time)}
        </Cell>
      ) : (
        <Cell />
      )}
      <Cell>
        {isNil(p.client_name) ? t(DEFAULT_CLIENT_NAME) : <TruncatedText max={24} suffix="..." value={p.client_name} />}
      </Cell>
      <Cell value={p.total_amount_paid_via_card || 0} />
      <Cell>{fixed(p.percentage * 100 || 0)}%</Cell>
      <Cell value={p.paid_amount || 0} />
      <Cell>
        <Permitted value={PERM.canViewDailyCashupAllStaff}>
          {hideModalForStylistsGroup && !hideModalForSubPaymentsGroup ? (
            <div onClick={() => onOpenModal(p.intentId)} role="button" tabIndex={0}>
              <Icon variant="info" width="md" />
            </div>
          ) : (
            p.transfer_destination || t('cashUp.transfers.unknownAccount')
          )}
        </Permitted>
        <Permitted value={PERM.canViewDailyCashupPersonal}>
          {!hideModalForSubPaymentsGroup ? (
            <div onClick={() => onOpenModal(p.intentId)} role="button" tabIndex={0}>
              <Icon variant="info" width="md" />
            </div>
          ) : (
            p.transfer_destination || t('cashUp.transfers.unknownAccount')
          )}
        </Permitted>
      </Cell>
    </div>
  );
};

export default SinglePayment;
